// extracted by mini-css-extract-plugin
export default {"textoUpper":"BannerDepoimentos_textoUpper__DyuFx","texto":"BannerDepoimentos_texto__1Gi3Y","nome":"BannerDepoimentos_nome__odxSN"};